const content = document.querySelector(".top-content");

if (content) {
    content.innerHTML += content.innerHTML;
}
let x = 0;
const speed = 0.8;

function marquee() {
    x -= speed;

    const halfWidth = content.scrollWidth / 2;

    if (Math.abs(x) >= halfWidth) {
        x = 0;
    }

    content.style.transform = `translate3d(${x}px,0,0)`;

    requestAnimationFrame(marquee);
}

window.addEventListener("load", marquee);

window.addEventListener("resize", () => {
    x = 0;
});


$('.customers-review-setn').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: '120px',
    speed: 700,

    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                centerMode: true,
                centerPadding: '60px'
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
                centerPadding: '0'
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0'
            }
        }
    ]
});


$('.discover-cards-setn').slick({

    slidesToShow: 4,
    slidesToScroll: 1,

    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,

    speed: 5000,
    cssEase: 'linear',

    arrows: false,
    dots: false,

    centerMode: true,
    centerPadding: '120px',

    pauseOnHover: false,
    pauseOnFocus: false,
    draggable: false,

    responsive: [

        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                centerPadding: '70px'
            }
        },

        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                centerPadding: '50px'
            }
        },

        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                centerMode: false,
                centerPadding: '0'
            }
        }

    ]

});

$('.power-routin-item').slick({
     slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    dots: false,

    centerMode: true,
    centerPadding: '0',

    responsive: [

        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                centerPadding: '70px'
            }
        },

        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                centerPadding: '50px'
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerPadding: '50px'
            }
        },

        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                centerMode: false,
                centerPadding: '0'
            }
        }

    ]

});
$(document).ready(function () {

    $('.hero-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 800,
        fade: true,
        adaptiveHeight: false
    });

});



$('.industry-slide-setn').slick({
     slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    dots: false,

    centerMode: true,
    centerPadding: '0',

    responsive: [

        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                centerPadding: '70px'
            }
        },

        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                centerPadding: '50px'
            }
        },

         {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
                centerPadding: '0'
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                centerMode: false,
                centerPadding: '0'
            }
        }

    ]

});





sal();

$(document).ready(function () {
    $('.review-card .pera-blk p').matchHeight();
})


const menuToggle = document.getElementById("menuToggle");
const navLinks = document.getElementById("navLinks");

menuToggle.addEventListener("click", () => {
    menuToggle.classList.toggle("active");
    navLinks.classList.toggle("active");
});

document.querySelectorAll("#navLinks a").forEach(link => {
    link.addEventListener("click", () => {
        menuToggle.classList.remove("active");
        navLinks.classList.remove("active");
    });
});





const $heroSlider = $('.hero-slider');

$heroSlider.on('init', function (event, slick) {

    const $firstSlide = $(slick.$slides[0]);

    // Force the first slide to start hidden
    $firstSlide.find(
        '.mainhead, .pera-blk, .hero-btn, .feature-item, .product-img'
    ).removeClass('hero-animate');

    // Wait until hidden state is painted
    requestAnimationFrame(function () {
        requestAnimationFrame(function () {

            $firstSlide.find(
                '.mainhead, .pera-blk, .hero-btn, .feature-item, .product-img'
            ).addClass('hero-animate');

        });
    });

});


$heroSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

    $(slick.$slides).find(
        '.mainhead, .pera-blk, .hero-btn, .feature-item, .product-img'
    ).removeClass('hero-animate');

});


$heroSlider.on('afterChange', function (event, slick, currentSlide) {

    const $current = $(slick.$slides[currentSlide]);

    requestAnimationFrame(function () {

        $current.find(
            '.mainhead, .pera-blk, .hero-btn, .feature-item, .product-img'
        ).addClass('hero-animate');

    });

});